import store from '../store';

const apiHost = process.env.VUE_APP_API_HOST;
const nodeApiHost = process.env.VUE_APP_NODE_API;

export default {
  menu : {
    fetchMenus: () => ({
      method: 'get',
      url: `${apiHost}/public-menu?show_all=true`,
    }),
  },
  auth: {
    signIn: data => ({
      method: 'post',
      url: `${apiHost}/api/token/`,
      data,
    }),
    signUp: data => ({
      method: 'post',
      url: `${apiHost}/users/user-registration-request/`,
      data,
    }),
    becomeMember: data => ({
      method: 'post',
      url: `${apiHost}/users/membership-request/`,
      data,
    }),
    setPassword: data => ({
      method: 'post',
      url: `${apiHost}/users/change-password/`,
      data: data,
    }),
    resendToken: data => ({
      method: 'post',
      url: `${apiHost}/users/resend-link/`,
      data,
    }),
    refresh: () => ({
      method: 'post',
      url: `${apiHost}/api/refresh-token/`,
      data: { refresh: store.getters['auth/refresh'] },
    }),
    addUserFirstSettings: data => ({
      method: 'patch',
      url: `${apiHost}/customers/${data.customerId}/`,
      headers: { Authorization: `Bearer ${data.access}` },
      data: data.userUpdate,
    }),
    addCompanyFirstSettings: data => ({
      method: 'post',
      url: `${apiHost}/companies/post-registration/`,
      headers: { Authorization: `Bearer ${data.access}` },
      data: data.companyUpdate,
    }),
    companySettingsSelects: type => ({
      method: 'get',
      url: `${apiHost}/company-configurations/?config_type=${type}&show_all=true`,
    }),
    addCompanyType: data => ({
      method: 'post',
      url: `${apiHost}/company-configurations/`,
      data,
    }),
  },
  tags: {
    fetch: () => ({
      method: 'get',
      url: `${apiHost}/tags/?show_all=true`,
    }),
    create: data => ({
      method: 'post',
      url: `${apiHost}/tag-recommendations/`,
      data,
    }),
    newTag: data => ({
      method: 'post',
      url: `${apiHost}/tags/`,
      data,
    }),
    createTags: data => ({
      method: 'post',
      url: `${apiHost}/users/tags/bulk-create/`,
      data,
    }),
  },
  core: {
    globalSearch: keyword => ({
      method: 'post',
      url: `${apiHost}/core/search`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: { keyword },
    }),
  },
  companies: {
    fetch: email => ({
      method: 'get',
      url: `${apiHost}/companies/?domain__icontains=${email}&show_all=true`,
    }),
    fetchInfo: companyUrl => ({
      method: 'get',
      url: companyUrl,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchCompany: companyId => ({
      method: 'get',
      url: `${apiHost}/companies/${companyId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    editCompanyInfo: data => ({
      method: 'patch',
      url: `${apiHost}/companies/${data.companyId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: data.editData,
    }),
    fetchAllCompanies: (orderBy = null) => ({
      method: 'get',
      url: `${apiHost}/companies/?show_all=true${orderBy ? `&order_by=${orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    searchCompanyByName: ({ name = '', page = 1 }) => ({
      method: 'get',
      url: `${apiHost}/companies/?search=${name}&page=${page}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchCompanyPublicInfo: id => ({
      method: 'get',
      url: `${apiHost}/companies/${id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    searchCompanyNetworkUser: ({ companyId, memberName = '', companyPage = 1 }) => ({
      method: 'get',
      url: `${apiHost}/customers/?company=${companyId}&name=${encodeURIComponent(memberName)}&page=${companyPage}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    followUnfollowCompany: data => ({
      method: 'post',
      url: `${apiHost}/companies/follow-unfollow-company/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    // `search` narrows the same paginated listing, so a search pages exactly
    // like the unfiltered list instead of pulling everything via show_all.
    fetchCompaniesList: (page = 1, orderBy = null, search = null) => ({
      method: 'get',
      url: `${apiHost}/companies/?page=${page}${search ? `&search=${encodeURIComponent(search)}` : ''}${orderBy ? `&order_by=${orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    registerCompany: data => ({
      method: 'post',
      url: `${apiHost}/companies/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    searchOnCompaniesList: (name, orderBy = null) => ({
      method: 'get',
      url: `${apiHost}/companies/?search=${name}&show_all=true${orderBy ? `&order_by=${orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    removeEmployee: id => ({
      method: 'post',
      url: `${apiHost}/companies/remove-employee/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: { employee: `${apiHost}/customers/${id}/` },
    }),
    changeCompany: data => ({
      method: 'post',
      url: `${apiHost}/companies/change/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    addRemoveAdmin: data => ({
      method: 'post',
      url: `${apiHost}/companies/add-remove-admin`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    addBillingAddress: data => ({
      method: 'post',
      url: `${apiHost}/companies/billing-address/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    fetchBillingAddress: id => ({
      method: 'get',
      url: `${apiHost}/companies/billing-address/?company=${id}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    updateBillingAddress: ({ data, billingId }) => ({
      method: 'patch',
      url: `${apiHost}/companies/billing-address/${billingId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    deleteBillingAddress: billingId => ({
      method: 'delete',
      url: `${apiHost}/companies/billing-address/${billingId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),

    fetchAdjustmentsWithId: id => ({
      method: 'get',
      url: `${apiHost}/payments/adjustments/?invoice=${id}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchPaymentEntities: () => ({
      method: 'get',
      url: `${apiHost}/payments/entities/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    companyWall: ({ page = 1, companyId }) => ({
      method: 'get',
      url: `${apiHost}/companies-wall/?page=${page}&company=${companyId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),

  },
  invoice: {
    getInvoiceParticipants: id => ({
      method: 'get',
      url: `${apiHost}/events/participant-customers?invoice=${id}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchInvoiceByCompanyId: companyId => ({
      method: 'get',
      url: `${apiHost}/payments/invoices/?company=${companyId}&show_all=true`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchInvoiceById: invoiceId => ({
      method: 'get',
      url: `${apiHost}/payments/invoices/${invoiceId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    updatePaymentStatus: updatedData => ({
      method: 'post',
      url: `${apiHost}/payments/payment-completed`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: updatedData,
    }),
    getPaymentAccount: data => ({
      method: 'post',
      url: `${apiHost}/payments/payment-accounts`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),

    changeInvoiceTransaction: data => ({
      method: 'post',
      url: `${apiHost}/payments/change-invoice-transaction`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    createStripeTransaction: data => ({
      method: 'post',
      url: `${apiHost}/payments/stripe-transaction`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    getStripeIntent: data => ({
      method: 'post',
      url: `${apiHost}/payments/stripe-intent`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    getPaymentSteps: invoice => ({
      method: 'get',
      url: `${apiHost}/payments/partial?invoice=${invoice}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
  },
  posts: {
    fetch: (page = 1, customerId) => ({
      method: 'get',
      url: `${apiHost}/posts/?page=${page}&user=${customerId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    create: data => ({
      method: 'post',
      url: `${apiHost}/posts/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    update: data => ({
      method: 'patch',
      url: `${apiHost}/posts/${data.id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    createPostMedia: data => ({
      method: 'post',
      url: `${apiHost}/posts-media/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    updatePostMedia: data => ({
      method: 'patch',
      url: `${apiHost}/posts-media/${data.id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    deletePostMedia: id => ({
      method: 'delete',
      url: `${apiHost}/posts-media/${id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    updateShared: data => ({
      method: 'patch',
      url: `${apiHost}/share-post/${data.id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    fetchSinglePost: id => ({
      method: 'get',
      url: `${apiHost}/posts/${id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchSingleSharedPost: id => ({
      method: 'get',
      url: `${apiHost}/share-post/${id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    shareUserPost: data => ({
      method: 'post',
      url: `${apiHost}/share-post/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    getUserWall: (page = 1) => ({
      method: 'get',
      url: `${apiHost}/users-wall/?page=${page}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    getMemberWall: (page = 1, customerId = null) => ({
      method: 'get',
      url: `${apiHost}/users-wall/?page=${page}${customerId ? `&user_id=${customerId}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchLatestCcUpdates: (companyId, startDate, endDate) => ({
      method: 'get',
      url: `${apiHost}/companies-wall/?company=${companyId}&start_date=${startDate}&end_date=${endDate}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    deletePost: postId => ({
      method: 'delete',
      url: `${apiHost}/posts/${postId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    deleteSharedPost: postId => ({
      method: 'delete',
      url: `${apiHost}/share-post/${postId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    getUsersSharedThePost: (postId) => ({
      method: 'get',
      url: `${apiHost}/share-post/?post=${postId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    reportPost: (reason, postUrl) => ({
      method: 'post',
      url: `${apiHost}/post-reports/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: { post: postUrl, reason },
    }),
  },
  postsLikeUnlike: {
    create: data => ({
      method: 'post',
      url: `${apiHost}/posts/like-dislike-post/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
  },
  sharedPostsLikeUnlike: {
    create: data => ({
      method: 'post',
      url: `${apiHost}/posts/like-dislike-post/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
  },
  comments: {
    fetch: postId => ({
      method: 'get',
      url: `${apiHost}/comments/?post=${postId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchShared: postId => ({
      method: 'get',
      url: `${apiHost}/comments/?shared_post=${postId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchNextPage: data => ({
      method: 'get',
      url: `${data}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    create: data => ({
      method: 'post',
      url: `${apiHost}/comments/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
  },
  events: {
    fetch: (tag = '') => ({
      method: 'get',
      url: `${apiHost}/events/?tag=${tag}&is_active=true&on_map=true&past_event=true&upcoming_events=true&booked_events=false`,
      // url: `${apiHost}/events/?tag=${tag}&upcoming_event=true&is_active=true&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchPastEvents: (page = 1) => ({
      method: 'get',
      url: `${apiHost}/all-events/?page=${page}&past_event=true&is_active=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchSingleEvent: eventId => ({
      method: 'get',
      url: `${apiHost}/events/${eventId}/`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchPreviousEdition: (id, type) => ({
      method: 'get',
      url: `${apiHost}/${type}/${id}`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchReasonsToAttend: eventId => ({
      method: 'get',
      url: `${apiHost}/events/reasons-to-attend/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchVenue: eventId => ({
      method: 'get',
      url: `${apiHost}/events/hotel-info/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchAllVenues: () => ({
      method: 'get',
      url: `${apiHost}/events/hotel-info/?show_all=true&&event__is_active=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchNearbyHotels: eventId => ({
      method: 'get',
      url: `${apiHost}/events/nearby-hotels/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchVenueCityImages: eventId => ({
      method: 'get',
      url: `${apiHost}/events/city-images/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    knowledgeSharingSession: eventId => ({
      method: 'get',
      url: `${apiHost}/events/knowledge-session/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    strategicSponsors: eventId => ({
      method: 'get',
      url: `${apiHost}/events/strategic-sponsors/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    parallelEvents: eventId => ({
      method: 'get',
      url: `${apiHost}/events/parallel-events/?event=${eventId}&is_active=true&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    accommodations: eventId => ({
      method: 'get',
      url: `${apiHost}/events/accommodations/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    speakersList: eventId => ({
      method: 'get',
      url: `${apiHost}/events/speakers/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    exhibitors: eventId => ({
      method: 'get',
      url: `${apiHost}/events/exhibitors/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    bookedTables: eventId => ({
      method: 'get',
      url: `${apiHost}/events/booked-tables/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    meetingRooms: eventId => ({
      method: 'get',
      url: `${apiHost}/events/meeting-rooms/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    participantMembers: ({ eventId, searchName = '', page = 1, orderBy, myNetwork } = {searchName: '', page: 1}) => ({
      method: 'get',
      url: `${apiHost}/events/participant-customers/?event=${eventId}&search=${searchName}&page=${page}&display=true${orderBy ? `&order_by=${orderBy}` : ''}${myNetwork ? '&my_network=true' : ''}`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    getEventParticipantMember: ({ eventId, customerId }) => ({
      method: 'get',
      url: `${apiHost}/events/participant-customers/?event=${eventId}&customer=${customerId}`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    participantCompanies: ({
      eventId, searchName = '', offset = 0, limit = 10,
    }) => ({
      method: 'get',
      url: `${apiHost}/events/participant-companies/?event=${eventId}&search=${searchName}&offset=${offset}&display=true&limit=${limit}`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    mediaDocs: ({ eventId, pdfType }) => ({
      method: 'get',
      url: `${apiHost}/events/download-media/?type=${pdfType}&event=${eventId}`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    eventPrices: eventId => ({
      method: 'get',
      url: `${apiHost}/events/entry-prices/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    awardPrices: awardId => ({
      method: 'get',
      url: `${apiHost}/awards/prices/?award=${awardId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchAgendaMaps: eventId => ({
      method: 'get',
      url: `${apiHost}/events/agenda/?event=${eventId}&on_map=true&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchAgenda: eventId => ({
      method: 'get',
      url: `${apiHost}/events/agenda/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchMeetingPlannerDays: eventId => ({
      method: 'get',
      url: `${apiHost}/events/days/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchGallery: eventId => ({
      method: 'get',
      url: `${apiHost}/events/gallery/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    eventBooking: bookingDetails => ({
      method: 'post',
      url: `${apiHost}/payments/book-event/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: bookingDetails,
    }),
    fetchEventsTags: () => ({
      method: 'get',
      url: `${apiHost}/events/tags/`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchAllEvents: (tag = '') => ({
      method: 'get',
      url: `${apiHost}/all-events/?tag=${tag}&upcoming_events=true&is_active=true&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    getAllEvents: (page = 1) => ({
      method: 'get',
      url: `${apiHost}/all-events?page=${page}`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchActiveEvents: (tag = '') => ({
      method: 'get',
      url: `${apiHost}/all-events/?tag=${tag}&is_active=true&active_events=true&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchUpcomingEvents: () => ({
      method: 'get',
      url: `${apiHost}/all-events/?page=1&upcoming_events=true&is_active=true&order_by=start_date`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchEventCategories: (eventId = '') => ({
      method: 'get',
      url: `${apiHost}/events/sponsor-categories/?event=${eventId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    becomePanelistOrSponsor: data => ({
      method: 'post',
      url: `${apiHost}/notification-system/become-panelist-or-sponsor`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    fetchEventSponsors: (categoryId = '') => ({
      method: 'get',
      url: `${apiHost}/events/sponsors-for-categories/?category=${categoryId}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchEventAllSponsors: id => ({
      method: 'get',
      url: `${apiHost}/events/sponsors-for-categories/?event=${id}&show_all=true`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    fetchBookedEvents: customerId => ({
      method: 'get',
      url: `${apiHost}/events/?tag=&is_active=true&on_map=&past_event=false&invoiced_to=${customerId}&order_by=start_date`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchEventHashtags: eventId => ({
      method: 'get',
      url: `${apiHost}/events/hashtags/?event=${eventId}`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
  },
  awards: {
    applyForCategory: data => ({
      method: 'post',
      url: `${apiHost}/awards/applicants/`,
      data,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    applyDocumentForCategory: data => ({
      method: 'post',
      url: `${apiHost}/awards/applicants-documents/`,
      data,
    }),
    editApplication: data => ({
      method: 'patch',
      url: `${apiHost}/awards/applicants/${data.id}`,
      data,
    }),
    editApplicationDocument: data => ({
      method: 'patch',
      url: `${apiHost}/awards/applicants-documents/${data.id}`,
      data,
    }),
    deleteApplication: id => ({
      method: 'delete',
      url: `${apiHost}/awards/applicants/${id}`,
    }),
    deleteApplicationDocument: id => ({
      method: 'delete',
      url: `${apiHost}/awards/applicants-documents/${id}`,
    }),
    fetchAwards: (page = 1) => ({
      method: 'get',
      url: `${apiHost}/awards/?page=${page}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchAward: awardId => ({
      method: 'get',
      url: `${apiHost}/awards/${awardId}/`,
    }),
    fetchJuries: awardId => ({
      method: 'get',
      url: `${apiHost}/awards/juries/?award=${awardId}&show_all=true`,

    }),
    fetchCategories: awardId => ({
      method: 'get',
      url: `${apiHost}/awards/categories/?award=${awardId}&show_all=true`,

    }),
    fetchAgendaMaps: awardId => ({
      method: 'get',
      url: `${apiHost}/awards/agenda/?award=${awardId}&on_map=true&show_all=true`,

    }),
    fetchAgenda: awardId => ({
      method: 'get',
      url: `${apiHost}/awards/agenda/?award=${awardId}&show_all=true`,

    }),
    fetchGallery: awardId => ({
      method: 'get',
      url: `${apiHost}/awards/gallery/?award=${awardId}&show_all=true`,

    }),
    fetchAwardCategories: (awardId = '') => ({
      method: 'get',
      url: `${apiHost}/awards/sponsor-categories/?award=${awardId}&show_all=true`,

    }),
    fetchAwardSponsors: (categoryId = '') => ({
      method: 'get',
      url: `${apiHost}/awards/sponsors/?category=${categoryId}&show_all=true`,

    }),
    fetchShortlisted: (categoryId = '') => ({
      method: 'get',
      url: `${apiHost}/awards/applicants/?category=${categoryId}&shortlisted=true`,

    }),
    fetchRegistrationList: (awardId = '') => ({
      method: 'get',
      url: `${apiHost}/awards/registration/?award=${awardId}&show_all=true`,
    }),
    participantCompanies: ({ awardId, searchName = '', offset = 0, limit = 10 }) => ({
      method: 'get',
      url: `${apiHost}/awards/participant-companies/?award=${awardId}&search=${searchName}&offset=${offset}&display=true&limit=${limit}`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    awardBooking: bookingDetails => ({
      method: 'post',
      url: `${apiHost}/payments/book-award/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: bookingDetails,
    }),
    fetchBookedAwards: customerId => ({
      method: 'get',
      url: `${apiHost}/awards/?tag=&is_active=true&on_map=&past_awards=false&invoiced_to=${customerId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchMyCompanyApplications: awardId => ({
      method: 'get',
      url: `${apiHost}/awards/applicants/my-company?award_id=${awardId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    sendEmailToApplicant: (data) => ({
      method: 'post',
      url: `${apiHost}/awards/applicants/send-email/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: data,
    }),
    fetchAwardQuestions: (awardId, customerId) => ({
      method: 'get',
      url: `${apiHost}/awards/questions/?award=${awardId}&customer=${customerId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    submitQuestionsAnswers: (awardId, customerId, data ) => ({
      method: 'post',
      url: `${apiHost}/awards/questions/?award=${awardId}&customer=${customerId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    fetchSubmission: (submissionId) => ({
      method: 'get',
      url: `${apiHost}/awards/applicants/${submissionId}`,
    }),
    fetchGCCWinners: (awardId) => ({
      method: 'get',
      url: `${apiHost}/awards/gcc-categories/?award=${awardId}&show_all=true`,
    }),
  },
  user: {
    fetch: (customerId, access) => ({
      method: 'get',
      url: `${apiHost}/customers/${customerId}/`,
      headers: { Authorization: `Bearer ${access}` },
    }),
    fetchUserInvoices: customerId => ({
      method: 'get',
      url: `${apiHost}/payments/invoices/?invoiced_to=${customerId}&show_all=true`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchUserInfo: customerId => ({
      method: 'get',
      url: `${apiHost}/customers/${customerId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    editUserInfo: (data, customerId) => ({
      method: 'patch',
      url: `${apiHost}/customers/${customerId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    changePassword: data => ({
      method: 'post',
      url: `${apiHost}/users/reset-password/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    forgotPassword: data => ({
      method: 'post',
      url: `${apiHost}/users/forgot-password/`,
      data,
    }),
    fetchUserPublicInfo: (customerId = '') => ({
      method: 'get',
      url: `${apiHost}/customers/${customerId}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    searchNetworkUser: ({
      customerId,
      memberName,
      companyId,
      membersPage = 1,
    }) => ({
      method: 'get',
      url: `${apiHost}/customers/network/?customer=${customerId}&search=${memberName}&network_member__company=${companyId}&page=${membersPage}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    searchOnContacts: ({ customerId, searchName, orderBy = null }) => ({
      method: 'get',
      url: `${apiHost}/customers/network/?customer=${customerId}&search=${searchName}&show_all=true${orderBy ? `&order_by=${orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchAllUsers: (userPage = 1, orderBy = null) => ({
      method: 'get',
      url: `${apiHost}/customers/?page=${userPage}${orderBy ? `&order_by=${orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchInvitationRequests: (customerId, page) => ({
      method: 'get',
      url: `${apiHost}/customers/invitation-request/?is_processed=false&requested_to=${customerId}&page=${page}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    sentInvitationRequests: (customerId, page) => ({
      method: 'get',
      url: `${apiHost}/customers/invitation-request/?is_processed=false&requested_by=${customerId}&page=${page}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    userInvitationRequest: data => ({
      method: 'post',
      url: `${apiHost}/customers/invitation-request/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    approveInvitationRequest: invitationUrl => ({
      method: 'patch',
      url: `${invitationUrl}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: { is_processed: true, accepted: true },
    }),
    refuseInvitationRequest: invitationUrl => ({
      method: 'patch',
      url: `${invitationUrl}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: { is_processed: true, accepted: false },
    }),
    userNetwork: (page = 1, orderBy = null) => ({
      method: 'get',
      url: `${apiHost}/customers/network/?page=${page}${orderBy ? `&order_by=${orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    AddToNetwork: added => ({
      method: 'post',
      url: `${apiHost}/customers/invitation-request/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: added,
    }),
    deleteFromNetwork: data => ({
      method: 'delete',
      url: data,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    deleteMember: data => ({
      method: 'delete',
      url: `${apiHost}${data}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    searchCustomer: (name, orderBy = null) => ({
      method: 'get',
      url: `${apiHost}/customers/?search=${name}&show_all=true${orderBy ? `&order_by=${orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    // Paginated counterpart of searchCustomer: an empty `name` is a plain
    // browse, so one endpoint backs both halves of a search-as-you-type list
    // and scrolling can never mix a filtered list with unfiltered pages.
    searchCustomersPage: ({ page = 1, name = '' } = {}) => ({
      method: 'get',
      url: `${apiHost}/customers/?page=${page}&search=${encodeURIComponent(name)}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    userRegister: data => ({
      method: 'post',
      url: `${apiHost}/users/register/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    findCustomers: ({ page = 1, name = '' }) => ({
      method: 'get',
      url: `${apiHost}/customers/search/?page=${page}&search=${name}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    addRemoveSpam: data => ({
      method: 'post',
      url: `${apiHost}/users/add-remove-spam/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
  },
  network: {
    fetchFollowers: data => ({
      method: 'get',
      url: `${apiHost}/customers/followers/?follower=${data.ownerId}&page=${data.page}${data.orderBy ? `&order_by=${data.orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchFollowersByTags: ({ ownerId, tagId, orderBy = null }) => ({
      method: 'get',
      url: `${apiHost}/customers/followers/?follower=${ownerId}&tags=${tagId}&show_all=true${orderBy ? `&order_by=${orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    userFollow: follow => ({
      method: 'post',
      url: `${apiHost}/customers/followers/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: follow,
    }),
    unFollowMember: data => ({
      method: 'delete',
      url: `${data}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    unFollowNetwork: data => ({
      method: 'delete',
      url: `${data}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    editContactFollowingStatus: ({ data, url }) => ({
      method: 'patch',
      url,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    searchOnFollowers: ({ ownerId, searchValue, orderBy = null }) => ({
      method: 'get',
      url: `${apiHost}/customers/followers/?follower=${ownerId}&search=${searchValue}&show_all=true${orderBy ? `&order_by=${orderBy}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    unfollowUserByCustomerId: (customerId) => ({
      method: 'patch',
      url: `${apiHost}/customers/network/unfollow/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: { customer_id: customerId },
    }),
  },
  mediaArchive: {
    getBase64Img: data => ({
      method: 'post',
      url: `${apiHost}/core/base64-gallery-image`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    likeEventMedia: data => ({
      method: 'post',
      url: `${apiHost}/events/media-archive/like-dislike/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    dislikeEventMedia: id => ({
      method: 'delete',
      url: `${apiHost}/events/media-archive/like-dislike/${id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    likeAwardMedia: data => ({
      method: 'post',
      url: `${apiHost}/awards/media-archive/like-dislike/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    dislikeAwardMedia: id => ({
      method: 'delete',
      url: `${apiHost}/awards/media-archive/like-dislike/${id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    shareImageAsPost: mediaData => ({
      method: 'post',
      url: `${apiHost}/share-media-files/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: mediaData,
    }),
    fetchImages: ({
      page = 1, event = '', year = '', award = '', search = '', distinct = false, show_all = false, tag = '',
    }) => ({
      method: 'get',
      url: `${apiHost}/media-archive/images?page=${page}&year=${year}&tag=${tag}&event=${event}&award=${award}&search=${search}&distinct=${distinct}&show_all=${show_all}`,
    }),
    fetchVideos: ({
      page = 1, event = '', year = '', search = '', award = '', tag = '',
    }) => ({
      method: 'get',
      url: `${apiHost}/media-archive/videos?page=${page}&year=${year}&award=${award}&tag=${tag}&event=${event}&search=${search}`,
    }),
    fetchPostGuide: ({
      page = 1, event = '', year = '', search = '', award = '', tag = '',
    }) => ({
      method: 'get',
      url: `${apiHost}/media-archive/post-guide?page=${page}&year=${year}&event=${event}&award=${award}&tag=${tag}&search=${search}`,
    }),
  },
  notifications: {
    fetchNotifications: ({ page, limit }) => ({
      method: 'get',
      url: `${apiHost}/notifications/?subject__icontains=&is_read=&is_archived=false&created=&search=&page=${page}&limit=${limit}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    // searchNotifications: search => ({
    //   method: 'get',
    //   url: `${apiHost}/notifications/?is_archived=false&search=${search}&show_all=true`,
    //   headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    // }),
    fetchUnreadNotifications: () => ({
      method: 'get',
      url: `${apiHost}/notifications/?is_read=false&is_archived=false&page=1`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchSingleNotification: id => ({
      method: 'get',
      url: `${apiHost}/notifications/${id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchSingleNotificationTemplate: id => ({
      method: 'get',
      url: `${apiHost}/notification-contents/${id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    editNotification: data => ({
      method: 'patch',
      url: `${apiHost}/notifications/${data.id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    getCurrentNotification: url => ({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
  },
  meetings: {
    getMeetingPlanner: event => ({
      method: 'get',
      url: `${nodeApiHost}/v1/meeting-planner?event=${event}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    customerMeetingPlanner: data => ({
      method: 'post',
      url: `${apiHost}/events/customer-meeting-planner/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    // @@Post request to invite meeting
    meetingPlannerInvitation: data => ({
      method: 'post',
      url: `${apiHost}/events/meeting/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    // @@get invitation data
    meetingPlannerInvitationList: ({ customerId, page }) => ({
      method: 'get',
      url: `${apiHost}/events/meeting-planner-invitation/?requested_to=${customerId}&page=${page}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    meetingPlannerRequestedBy: customerId => ({
      method: 'get',
      url: `${apiHost}/events/meeting-planner-invitation/?requested_by=${customerId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    // @@patch approved or reject
    acceptOrRefuseInvitation: data => ({
      method: 'patch',
      url: `${apiHost}/events/meeting-planner-invitation/${data.id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    editMeeting: data => ({
      method: 'patch',
      url: `${apiHost}/events/meeting/${data.id}/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    fetchSingleMPInvitation: invitationId => ({
      method: 'get',
      url: `${apiHost}/events/meeting-planner-invitation/${invitationId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    deleteMeeting: id => ({
      method: 'delete',
      url: `${apiHost}/events/meeting/${id}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data: { id },
    }),
    meetingPlannerSlotBlock: data => ({
      method: 'post',
      url: `${apiHost}/events/block-planner/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    meetingPlannerSlotUnblock: id => ({
      method: 'delete',
      url: `${apiHost}/events/block-planner/${id}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },

    }),
    cancelMeetingInvitation: data => ({
      method: 'post',
      url: `${apiHost}/events/cancel-meeting/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    getMeetingSponsors: id => ({
      method: 'get',
      url: `${apiHost}/events/meeting-planner-sponsors/?event=${id}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
  },
  mediaChannels: {
    get: (page = 1) => ({
      method: 'get',
      url: `${apiHost}/media-channels?page=${page}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}`, 'Access-Control-Allow-Origin': '*' },

    }),
  },
  aiChat: {
    send: (data) => ({
      method: 'post',
      url: `${nodeApiHost}/v1/ai/chat`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    access: () => ({
      method: 'get',
      url: `${nodeApiHost}/v1/ai/access`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
  },
  messages: {
    // @@get all conversations
    conversationList: (conversationId, page = 1, keyword = '') => ({
      method: 'get',
      url: `${nodeApiHost}/v1/conversations/${conversationId}?page=${page}${keyword ? `&keyword=${keyword}` : ''}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}`, 'Access-Control-Allow-Origin': '*' },
    }),
    currentChatDetails: conversationId => ({
      method: 'get',
      url: `${nodeApiHost}/v1/conversations/${conversationId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    // @@get current conversation
    currentConversation: (chatRoomId = '', page = 1) => ({
      method: 'get',
      url: `${nodeApiHost}/v1/conversations/messages/${chatRoomId}?page=${page}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    fetchAllUsersForChat: ({ name = '', page = 1 } = {}) => ({
      method: 'get',
      url: `${nodeApiHost}/v1/users/?page=${page}&keyword=${name}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    // @@Post new message
    createNewConversation: data => ({
      method: 'post',
      url: `${nodeApiHost}/v1/conversations/`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    // @@Global search message
    searchGlobalMessages: searchValue => ({
      method: 'get',
      url: `${nodeApiHost}/v1/messages?keyword=${searchValue}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    // @@ Search conversation message
    searchConversationMessages: ({ chatRoomId, searchValue }) => ({
      method: 'get',
      url: `${nodeApiHost}/v1/conversations/messages/${chatRoomId}?keyword=${searchValue}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    // @@ Get message context (neighboring messages)
    getMessageContext: ({ chatRoomId, messageId }) => ({
      method: 'get',
      url: `${nodeApiHost}/v1/conversations/messages-context/${chatRoomId}?messageId=${messageId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    // @@patch req pin messages to top
    pinMessageToTop: data => ({
      method: 'patch',
      url: `${nodeApiHost}/v1/conversations/pin-to-top`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    unPinMessage: data => ({
      method: 'patch',
      url: `${nodeApiHost}/v1/conversations/unpin`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    // @@block conversation
    blockConversation: data => ({
      method: 'patch',
      url: `${nodeApiHost}/v1/conversations/block`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    // @@unblock conversation
    unblockConversation: chatId => ({
      method: 'patch',
      url: `${nodeApiHost}/v1/conversations/unblock/${chatId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      chatId,
    }),
    // @@get blacklist
    blacklist: () => ({
      method: 'get',
      url: `${nodeApiHost}/v1/conversations/?is_blocked=1`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    // @@hide conversation
    hideConversation: data => ({
      method: 'patch',
      url: `${nodeApiHost}/v1/conversations/hide`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
    removeConversation: chatRoomId => ({
      method: 'delete',
      url: `${nodeApiHost}/v1/conversations/messages/${chatRoomId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    getUnreadMessagesCount: () => ({
      method: 'get',
      url: `${nodeApiHost}/v1/conversations/messages/unread-messages-count`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    getChatRoomId: receiverId => ({
      method: 'get',
      url: `${nodeApiHost}/v1/conversations/messages/chat-room-id?receiver_id=${receiverId}`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    sendEmail: data => ({
      method: 'post',
      url: `${apiHost}/notification-system/first-message`,
      data,
    }),
    sendMessageViaNodeJSServer: data => ({
      method: 'post',
      url: `${nodeApiHost}/v1/messages/send-message`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
  },
  // globalSettings: {
  //   fetchStyles: () => ({
  //     method: 'get',
  //     url: `${apiHost}/global-styles/1/`,
  //   }),
  // },
  advertisement: {
    fetchAdvertisementBanners: type => ({
      method: 'get',
      url: `${apiHost}/banners/?type=${type}&show_all=true&is_active=true`,

    }),
    fetchEventBanners: (eventId, type) => ({
      method: 'get',
      url: `${apiHost}/banners/?event=${eventId}&type=${type}&is_active=true&show_all=true`,
    }),
    fetchHomePagePopupBanner: (type = 'homePagePopup') => ({
      method: 'get',
      url: `${apiHost}/banners/?type=${type}&is_active=true&show=true`,
    }),
  },
  customForms: {
    fetchCustomForm: slug => ({
      method: 'get',
      url: `${apiHost}/custom-forms/${slug}/`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
    }),
    submitCustomFormSubmission: data => ({
      method: 'post',
      url: `${apiHost}/custom-forms-submissions/`,
      headers: store.getters['auth/access'] ? { Authorization: `Bearer ${store.getters['auth/access']}` } : {},
      data,
    }),
  },
  notificationSettings: {
    fetch: () => ({
      method: 'get',
      url: `${apiHost}/notification-system/user-notification-settings`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
    }),
    update: data => ({
      method: 'patch',
      url: `${apiHost}/notification-system/user-notification-settings`,
      headers: { Authorization: `Bearer ${store.getters['auth/access']}` },
      data,
    }),
  },
};
